/* tslint:disable */
/* eslint-disable */
/* @relayHash 3d9b890d5ac7f8d8bf118ea6bb25fa38 */

import { ConcreteRequest } from "relay-runtime";
export type CreateWordOrderAnswerInput = {
    studyRecordId: string;
    exerciseId: string;
    response: Array<string>;
    isCorrect: boolean;
    clientMutationId?: string | null;
};
export type CreateWordOrderAnswerMutationVariables = {
    input: CreateWordOrderAnswerInput;
};
export type CreateWordOrderAnswerMutationResponse = {
    readonly createWordOrderAnswer: {
        readonly answer: {
            readonly id: string;
        } | null;
    } | null;
};
export type CreateWordOrderAnswerMutation = {
    readonly response: CreateWordOrderAnswerMutationResponse;
    readonly variables: CreateWordOrderAnswerMutationVariables;
};



/*
mutation CreateWordOrderAnswerMutation(
  $input: CreateWordOrderAnswerInput!
) {
  createWordOrderAnswer(input: $input) {
    answer {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateWordOrderAnswerInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createWordOrderAnswer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateWordOrderAnswerPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "answer",
        "storageKey": null,
        "args": null,
        "concreteType": "WordOrderAnswer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateWordOrderAnswerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateWordOrderAnswerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateWordOrderAnswerMutation",
    "id": null,
    "text": "mutation CreateWordOrderAnswerMutation(\n  $input: CreateWordOrderAnswerInput!\n) {\n  createWordOrderAnswer(input: $input) {\n    answer {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'e2c98d686a1c2ef751116a811d0bb15d';
export default node;
